import React from "react";
import { Badge } from "@/components/ui/badge";

const ROLE_STYLE = {
  "Client": "bg-seagreen/10 text-seagreen border-seagreen/30",
  "Prospect": "bg-seaamber/10 text-seaamber border-seaamber/30",
  "Former Client": "bg-cloud text-slate border-border",
  "Business Relationship": "bg-atlantic/10 text-atlantic border-atlantic/30",
};

// Renders each additive relationship role as its own badge. Entity type is intentionally
// shown separately by the caller — roles are NOT the entity type.
export function RoleBadges({ roles = [], businessRelationship = false, testid, className = "" }) {
  const list = [...(roles || [])];
  if (businessRelationship) list.push("Business Relationship");
  const seen = new Set();
  const unique = list.filter((r) => r && !seen.has(r) && seen.add(r));
  if (unique.length === 0) unique.push("Client");
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid={testid}>
      {unique.map((r) => (
        <Badge key={r} variant="outline"
          className={`${ROLE_STYLE[r] || "bg-ice text-atlantic border-sky/50"} text-[10px] uppercase tracking-wide font-semibold`}
          data-testid={`role-badge-${String(r).toLowerCase().replace(/\s+/g, "-")}`}>{r}</Badge>
      ))}
    </div>
  );
}

export default RoleBadges;
